import { parcels as parcelsApi } from '@afosto/fulfilment/api/Parcels';
import scheduleFileTasks from './scheduleFileTasks';

const fetchPackingSlips = async parcels => {
  try {
    const promises = parcels.map(parcel => parcelsApi.requestSlip(parcel.id));
    return scheduleFileTasks(promises);
  } catch (err) {
    return Promise.reject(err);
  }
};

export default fetchPackingSlips;
